module.exports = __webpack_public_path__ + "img/settings.b45db7c.svg";